import styled from 'styled-components'
import theme from '../../../common/theme'

export const Background = styled.div`
  background-image: url('/images/homepage/newsletter.png');
  padding: 130px 0px;
`
export const Button = styled.a`
  background-color: ${theme.color.blue};
  color: ${theme.color.white};
  padding: 7px 45px;
  border-radius: 11px;
  cursor: pointer;
  font-weight: 600;
  width: 300px;

  @media (max-width: 992px) {
    margin-bottom: 32px;
    padding: 7px 27px;
  }
`

export const Title = styled.h3`
  font-size: 40px;
  font-weight: bold;
  line-height: 40px;
  @media (max-width: 992px) {
    margin-bottom: 32px;
  }
`
